import bbitApi from '@api/make-request'
import {
  IPathParamsArgs,
  IRepository,
  numberArgs,
} from '@api/repositories/i-repository'
import {
  IOrganizationSchedule,
  IOrganizationScheduleCreate,
  IOrganizationSchedulePartialUpdate,
  IOrganizationScheduleUpdate,
} from '@app/interfaces/organization/organization-schedule'
import { resolveParams } from '@app/utils/resolve-params/resolve-params'
import { AxiosResponse } from 'axios'

class OrganizationScheduleRepository
  implements IRepository<IOrganizationSchedule>
{
  create(
    data: IOrganizationScheduleCreate,
  ): Promise<AxiosResponse<IOrganizationSchedule>> {
    return bbitApi.post('/dictionary/api/v1/organization-schedule', data)
  }

  getAll(
    args: IPathParamsArgs,
  ): Promise<AxiosResponse<IOrganizationSchedule[]>> {
    return bbitApi.get('/dictionary/api/v1/organization-schedule', {
      cancelToken: args.source?.token,
      params: resolveParams(args),
    })
  }

  getOne(args: numberArgs): Promise<AxiosResponse<IOrganizationSchedule>> {
    return bbitApi.get(
      `/dictionary/api/v1/organization-schedule/${args.data}`,
      {
        cancelToken: args.source?.token,
      },
    )
  }

  update(
    data: IOrganizationScheduleUpdate,
  ): Promise<AxiosResponse<IOrganizationSchedule>> {
    return bbitApi.put(
      `/dictionary/api/v1/organization-schedule/${data.id}`,
      data,
    )
  }

  partialUpdate(
    data: IOrganizationSchedulePartialUpdate,
  ): Promise<AxiosResponse<IOrganizationSchedule>> {
    return bbitApi.put(
      `/dictionary/api/v1/organization-schedule/${data.id}`,
      data,
    )
  }
}

export default new OrganizationScheduleRepository()
